import React from "react";
import { withTranslation } from "react-i18next";
import SelectBox from "../../../components/SelectBox";
import DateTime from "../../../components/DateTime";
import { Grid } from "@material-ui/core";
import "./AttendanceFilters.css";

function AttendanceFilters({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  statusFilter,
  onStatusFilterChange,
  searchTerm,
  onSearchChange,
  workers,
  selectedWorkers,
  onWorkersChange,
  t,
  showDateRange = true,
  showWorkerFilter = false,
}) {
  const statusOptions = [
    { id: "all", name: t("Todos") },
    { id: "clocked_in", name: t("Presente") },
    { id: "clocked_out", name: t("Ausente") },
  ];

  return (
    <div className="attendance-filters">
      <Grid container spacing={2} alignItems="center">
        {showDateRange && (
          <>
            <Grid item xs={12} sm={6} md={3}>
              <div className="form-group">
                <label htmlFor="start_date">{t("Data Início")}</label>
                <DateTime
                  value={startDate}
                  onChange={onStartDateChange}
                  id="start_date"
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <div className="form-group">
                <label htmlFor="end_date">{t("Data Fim")}</label>
                <DateTime
                  value={endDate}
                  onChange={onEndDateChange}
                  id="end_date"
                />
              </div>
            </Grid>
          </>
        )}

        <Grid item xs={12} sm={6} md={3}>
          <div className="form-group">
            <label htmlFor="status_filter">{t("Filtrar por Status")}</label>
            <SelectBox
              data={statusOptions}
              selected_value={statusFilter}
              value="name"
              change={onStatusFilterChange}
              id="status_filter"
            />
          </div>
        </Grid>

        <Grid item xs={12} sm={6} md={3}>
          <div className="form-group">
            <label htmlFor="search">{t("Buscar por nome ou CPF")}</label>
            <input
              type="text"
              className="form-control"
              placeholder={t("Buscar por nome ou CPF")}
              value={searchTerm}
              onChange={onSearchChange}
              id="search"
            />
          </div>
        </Grid>

        {showWorkerFilter && workers && workers.length > 0 && (
          <Grid item xs={12} md={6}>
            <div className="form-group">
              <label htmlFor="worker_filter">
                {t("Selecionar Trabalhadores")}
              </label>
              <select
                multiple
                className="form-control"
                value={selectedWorkers}
                onChange={onWorkersChange}
                id="worker_filter"
                style={{ height: "120px" }}
              >
                <option value="all">{t("Todos os Trabalhadores")}</option>
                {workers.map((worker) => (
                  <option key={worker.id} value={worker.id}>
                    {worker.first_name} {worker.last_name} - {worker.cpf}
                  </option>
                ))}
              </select>
            </div>
          </Grid>
        )}
      </Grid>
    </div>
  );
}

export default withTranslation()(AttendanceFilters);
